// extracted by mini-css-extract-plugin
module.exports = {"emailCaptureContainer":"ComingSoonEmailCapture_emailCaptureContainer__YuQ44","comingSoonCTAContent":"ComingSoonEmailCapture_comingSoonCTAContent__QzSk8"};